module.exports = __webpack_public_path__ + "static/media/brasil_new_pastures-mobile.eec2fc7f.jpg";